import { Helmet } from "react-helmet";
import "../styles/Rates.css"; // (Create styling separately)

function Rates() {
  return (
    <section id="rates" aria-labelledby="rates-heading">
      <Helmet>
        <title>Personal Training Rates | Lu - Fit Cape Town</title>
        <meta
          name="description"
          content="Explore private personal training session prices, group classes, and package discounts at Lu - Fit in Cape Town."
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Personal Training",
            "provider": {
              "@type": "LocalBusiness",
              "name": "Lu - Fit",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Cape Town",
                "addressRegion": "Western Cape",
                "addressCountry": "ZA"
              }
            },
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Training Rates",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "60min Private Session"
                  },
                  "price": "400",
                  "priceCurrency": "ZAR"
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "45min Private Session"
                  },
                  "price": "300",
                  "priceCurrency": "ZAR"
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "30min Private Session"
                  },
                  "price": "200",
                  "priceCurrency": "ZAR"
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "10-Class Package"
                  },
                  "price": "3600",
                  "priceCurrency": "ZAR",
                  "description": "Save 10% with this bundle"
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "15-Class Package"
                  },
                  "price": "5100",
                  "priceCurrency": "ZAR",
                  "description": "Save 15% with this bundle"
                }
              ]
            }
          })}
        </script>
      </Helmet>

      <div className="rates-header">
        <h2 id="rates-heading">Personal Training Rates</h2>
        <p className="rates-intro">
          Transparent pricing for private sessions, group classes, and discounted training packages with Lu - Fit.
        </p>
      </div>

      <div className="rates-grid">
        {/* Private Classes */}
        <article className="rate-box" aria-labelledby="private-heading">
          <img
            src="/media/images/image-rates-1.webp"
            alt="Personal trainer coaching a client during pull-up"
            loading="lazy"
            className="rate-bg"
          />
          <div className="rate-content">
            <h3 id="private-heading">Private Classes</h3>
            <dl>
              <div>
                <dt className="rate-price">R400</dt>
                <dd>60min Private Session</dd>
              </div>
              <div>
                <dt className="rate-price">R300</dt>
                <dd>45min Private Session</dd>
              </div>
              <div>
                <dt className="rate-price">R200</dt>
                <dd>30min Private Session</dd>
              </div>
            </dl>
            <h4>Group Classes</h4>
            <p>Contact us for group training rates & availability.</p>
          </div>
        </article>

        {/* Packages */}
        <article className="rate-box" aria-labelledby="packages-heading">
          <img
            src="/media/images/image-rates-2.webp"
            alt="Boxing training in gym with personal trainer"
            loading="lazy"
            className="rate-bg"
          />
          <div className="rate-content">
            <h3 id="packages-heading">Training Packages</h3>
            <div className="rate-package">
              <strong>Save 10%</strong>
              <p>10-Class Package</p>
            </div>
            <div className="rate-package">
              <strong>Save 15%</strong>
              <p>15-Class Package</p>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}

export default Rates;
